export default __webpack_public_path__ + "static/media/Embedded.46b04a28.png";